var map = {
	"./ic_upload_file.png": 6649,
	"./img_colors1_scs.png": 4507,
	"./img_dashboard.png": 9450,
	"./img_faq.png": 6346,
	"./img_insight.png": 3434,
	"./img_logo_scs.png": 3021,
	"./img_reward.png": 3509,
	"./img_trips.png": 7626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;